import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from './errors';

/** Retry transient failures once; never retry a client error (4xx) or a 401. */
const shouldRetry = (failureCount: number, error: unknown): boolean => {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 1;
};

export const createQueryClient = (): QueryClient =>
  new QueryClient({
    queryCache: new QueryCache(),
    mutationCache: new MutationCache(),
    defaultOptions: {
      queries: {
        // Reporting data changes on the scale of hours; 30s avoids refetch
        // storms on navigation while keeping a screen honest on return.
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: shouldRetry,
        refetchOnWindowFocus: false,
        // Keep the previous result on screen while a new scope loads; the
        // DataState wrapper shows it as refreshing, never as empty.
        placeholderData: (previous: unknown) => previous,
      },
      mutations: { retry: false },
    },
  });
